import { includes } from 'lodash';
import {
	SAL_CONTENT_TYPE_BASIC, SAL_CONTENT_TYPE_PREMIUM, NO_MIP_ANALYSIS_EDITIONS, NO_EQSV_SUSTAINABILITY_EDITIONS, NO_PARENT_PILLAR_CARDS_EDITIONS
} from '../../constants.js';

/* eslint-disable quote-props */
export default {
	computed: {
		appConfig() {
			const {
				benchmarkId,
				contentType,
				edition,
				labels,
				securityId,
				securityType
			} = this;

			return {
				settings: {
					languageId: edition,
					sal: {
						integration: {
							id: 'MDC'
						},
						investment: {
							benchmarkId,
							fundServCode: '',
							id: securityId,
							marketUserGroup: '',
							type: securityType
						},
						service: {
							baseUrl: 'https://api-global.morningstar.com/sal-service/v1/',
							httpWithCredentials: true,
							keyApigee: process.env.VUE_APP_SAL_APIGEE_KEY,
							salContentType: contentType,
							tokenRealtime: process.env.VUE_APP_ACCESS_TOKEN
						},
						usageService: {
							baseUrl: false
						}
					}
				},
				labels,
				components: {
					salGmb: {
						settings: {
							languageId: edition
						}
					}
				}
			};
		},
		tradingInfoTemplates() {
			if (this.securityType === 'EQ') {
				const exchange = this.exchange.toLowerCase();
				let template = 'global';

				if (includes(['xase', 'xnas', 'xnys'], exchange)) {
					template = 'usa';
				} else if (includes(['xcnq', 'xtse', 'xtsx'], exchange)) {
					template = 'can';
				}

				return {
					CAN: template,
					GLOBAL: template,
					USA: template
				};
			}
		},
		canShowPremiumContent() {
			return this.contentType === SAL_CONTENT_TYPE_PREMIUM;
		},
		canShowMipAnalysis() {
			return this.canShowPremiumContent && !NO_MIP_ANALYSIS_EDITIONS.includes(this.edition);
		},
		canShowEqsvSustainability() {
			return !['FO', 'FE'].includes(this.securityType) && !NO_EQSV_SUSTAINABILITY_EDITIONS.includes(this.edition);
		},
		canShowPillarCardsParent() {
			return !NO_PARENT_PILLAR_CARDS_EDITIONS.includes(this.edition);
		}
	},
	data() {
		return {
			loaded: false
		};
	},
	mounted() {
		window.mwc.configuration.setAppConfig(this.appConfig);

		this.loaded = true;
	},
	props: {
		benchmarkId: {
			type: String,
			default: 'mstarorcat'
		},
		contentType: {
			type: String,
			default: SAL_CONTENT_TYPE_BASIC
		},
		edition: {
			type: String,
			default: 'en-ca'
		},
		exchange: {
			type: String,
			default: ''
		},
		internationalRequestTemplates: {
			type: String,
			default: null
		},
		labels: {
			type: Object,
			default: () => ({})
		},
		securityId: {
			type: String,
			default: ''
		},
		securityType: {
			type: String,
			default: ''
		},
		countryCodeFilter: {
			type: Array,
			default: () => []
		}
	}
};
